export default __webpack_public_path__ + "static/fullstory-favicon-c406425a927e614237df2905dca82194.svg";